/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, {
  useCallback, useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import {
  connect, useSelector, shallowEqual, useDispatch,
} from 'react-redux';
import swal from 'sweetalert';
import _ from 'lodash';
import { mapDispatchToProps } from '../../../store/externalCalls/api/formApi';
import { composeURL, checkObjectAttributes } from '../../../utils/urlTools';
import PageTitle from '../../organisms/pageTitle/pageTitle';
import SimplePageTitle from '../../molecules/pageTitle/pageTitle';
import { storeStructure } from '../../../store/reducers';
import FormGroup from '../../organisms/formGroup/formGroup2';
import { updateForm } from '../../../store/actions/formActions';
import FooterWizardButtons from '../../molecules/formFooter/formFooterWizard';
import { createSession, removeSession, updateSession } from '../../../store/actions/sessionActions';
import Broadcast from '../../../store/externalCalls/broadcast';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import Stepper from '../../molecules/stepper/stepper';
import { Form, Toast } from 'react-bootstrap';
import { httpPost, httpPut } from '../../../store/externalCalls/httpCalls';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import Modal,{ ModalSize } from '../../molecules/modal/modal';
import FormInputText from '../../molecules/formInputText/formInputText';
import Toaste from '../../atoms/toast/toaste';
import { getCookie } from '../../../store/sessionStore';
import FormPopup from '../../molecules/formPopup/formPopup';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';

let stopSocketMessages=false;
let storeSocketMessages=[];
let storeSocketNavigationMessages=[];

const FormWizardTemplate = (props) => {
  const {
    getItem,
    getAdditionalMetadata,
    resetAdditionalMetadata,
    resetForm,
    updateItem,
    updateLocalItem,
    deleteItem,
    configFile,
    history,
    match,
  } = (props);
  const dispatch = useDispatch();
  const paramsHook = useParams();
  const navigate = useNavigate();
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const values = useSelector((state) => state[storeStructure.FormData], shallowEqual);
  const [disableForm, setDisableForm] = useState(false);
  const [disabledBack,setDisabledBack]=useState(true);
  const [visibleFinish,setVisibleFinish] =useState(false);
  const [visibleYamlSent,setVisibleYamlSent] =useState(false);
  const [visibleDisplaySignaling,setVisibleDisplaySignaling]=useState(false);
  const [visibleDisplayYaml,setVisibleDisplayYaml]=useState(false);
  const [signaling,setSignaling] =useState(null);
  const [yaml,setYaml]=useState(null);
  const [showPopupSignaling,setShowPopupSignaling] =useState(false);
  const [showPopupYaml,setShowPopupYaml] =useState(false);
  const [visibleNext,setVisibleNext] =useState(false);
  const [currentStep,setCurrentStep] =useState(null);
  const [currentStepValues,setCurrentStepValues]=useState(null);
  const [formHasChanged,setFormHasChanged] =useState(false);
  const [page,setPage] = useState(null);
  const location = useLocation();
  const [templateName,setTemplateName] =useState(null);
  const additionalMetadata = useSelector(
    (state) => state[storeStructure.AdditionalMetadata], shallowEqual,
  );
  const itemChanged = useSelector((state) => state.session.isBlocking);
  const [errors, setErrors] = useState({});
  const [infos, setInfos] = useState({});
  const [websocketLogOpen, setWebsocketLogOpen] = useState(false);
  const errorRef = useRef(null);
  const infosRef = useRef(null);
  const id = configFile.idAttribute !== undefined
    ? paramsHook[configFile.idAttribute] : undefined;
  const label = configFile.label ? configFile.label : '';
  const [showModalTemplate,setShowModalTemplate] =useState(false);
  const [popupErrors,setPopupErrors] =useState({});
  const [userNavigation,setUserNavigation] =useState([]);
  const serializedState = getCookie('state');
  const calculateUserNavigation=(userNavigationValues)=>{
    let navURL=configFile.getURL;
    if(configFile.idAttribute)
      navURL=composeURL(null,null,configFile.getURL,id);
    
    let pageUserNav=[];
    userNavigationValues.forEach((item)=>{
      if(item.page==process.env.REACT_APP_API_ENDPOINT+navURL){
        pageUserNav.push(item);
      }
    });
    setUserNavigation(pageUserNav);
  }
 
  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;
    setErrors(messages);
    setTimeout(() => {
      setErrors({});
    }, 10000);
    setDisableForm(false);
  };

  const delayedQuery = useCallback(_.debounce((valueChanged) => {
    const { url, ...rest } = valueChanged;
    if (!valueChanged.composeExperienceUrls) {
      rest.composeExperienceUrls = rest.urlId;
    }

    dispatch(updateForm(valueChanged));
    if (id !== 'new') {
      updateItem(`${composeURL(session, configFile.sessionParams, configFile.updateURL)}/${valueChanged.id}`, rest)
        .then({}, (e) => {
          const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
          getItem(url);
          handlerErrors(e);
        });
    } 
  }, 300), [session, configFile]);

  const getStepAttribute=(step)=>{
    return configFile.stepConfig.steps[step-1].attributeName;
  }
  const handlerOnChange = (valueChanged) => {
    if (valueChanged) {
      let stepAttribute= getStepAttribute(currentStep);
      const newValues={...values,[stepAttribute]:{...values[stepAttribute],...valueChanged}};
      dispatch(updateForm(newValues));
      setFormHasChanged(true);
      setVisibleDisplaySignaling(false);
      setVisibleDisplayYaml(false);
      setSignaling(null);
      setYaml(null);
      stopSocketMessages=true;
    }
  };
  
  const handlerNextbutton = () => {
    checkValidationStep(currentStep).then((res) => {
      if (res.value) {
        dispatch(updateForm(res.value));
        setInfos({info: ['Information stored successfully']});
        setTimeout(() => {
          setInfos({});
        }, 2000);
      }
      
      if (res.isNew) {
        return;
      }

      const newStep = currentStep + 1;
      setCurrentStep(newStep);
      setCurrentStepValues(configFile.stepConfig.steps[newStep - 1].formConfig);
      checkStep(newStep, configFile.stepConfig.steps.length);
      const shouldKeepChanged = (values?.isTemplate && !values?.statusHash)  || checkDynamicCondition(configFile.forceChangedWhen, values);
      setFormHasChanged(shouldKeepChanged);
    }).catch(error=>{
      if(error && error.errors){
        const messages = error.errors;
        if(messages.refresh){
            setTimeout(() => {
              window.location.reload();
          }, 4000);
          }
            setErrors(messages);
            setTimeout(() => {
              setErrors({});
          }, 5000);
    
    }else{
      console.log("unknown error");
    }
   });
  }
  const handlerBackButton=()=>{
    let newStep=currentStep-1;
    setCurrentStep(newStep);
    setCurrentStepValues(configFile.stepConfig.steps[newStep-1].formConfig);
    setVisibleYamlSent(false);
    checkStep(newStep,configFile.stepConfig.steps.length)
    setFormHasChanged(false);
  }
  const handlerFinishButton=()=>{
    // console.log("current values",values);
    checkValidationStep(currentStep).then((res)=>{
      if(res.status=="ok")
        setVisibleYamlSent(true);
      setVisibleFinish(true);
      setFormHasChanged(false);
      stopSocketMessages=false;
      if(res.value){
        dispatch(updateForm(res.value));
        setInfos({ info:["Information stored successfully"]});
        setTimeout(() => {
          setInfos({});
        }, 2000);
      }
      
    }).catch(error=>{
      const messages = error.errors;
          setErrors(messages);
          setTimeout(() => {
            setErrors({});
        }, 5000);
    });  
  }

  const handlerSaveTemplate=()=>{
    let editId;
    if(paramsHook.id!="new")
      editId=paramsHook.id;
      setTemplateName("");
      setShowModalTemplate(true);
  }

  const handlePopupOK=()=>{
    let params={name:templateName,id:paramsHook.id};
    let saveTemplateUrl="templateCreationFromLive";
    httpPost(saveTemplateUrl, params).then((res)=>{
      if(res.status==true){
        setShowModalTemplate(false);
        navigate("/assetsmanager/livetemplates", {
           state: {
            from: location.pathname,
          },
        });
      }else{
        setPopupErrors(res.errors);
        setTimeout(() => {
          setPopupErrors({});
        }, 2000);
      }
    }).catch(error=>{
      setPopupErrors(error.errors);
      setTimeout(() => {
        setPopupErrors({});
      }, 2000);
    });
  }
  
  const handlerDisplaySignaling=()=>{
    if(signaling){
      setShowPopupSignaling(true);
    }
  }
  const handlerDisplayYaml=()=>{
    if(yaml){
      setShowPopupYaml(true);
    }
  }
  const handlerYamlSentButton=()=>{
    let params={'step':'yaml'};
    let editId;
    let validationUrl=configFile.stepConfig.validationUrl;
    if(paramsHook.id!="new")
      editId=paramsHook.id;
      swal({
        title: 'Send Yaml to liveBackendApi?',
        text: "You are about to send the live event for processing ",
        icon: 'warning',
        buttons:["Cancel","Send"],
        // dangerMode: true,
      }).then((ok) => {
        if(ok){
          sendYaml(validationUrl+"/"+editId,params,editId);
        }
      }).catch(e=>{
          if(e.errors){
            swal('Error', e.errors.error[0], 'error');
          }
      });
  }
  const canDisplaySignalingButton=()=>{
    if(values["globalLive"]["deploymentType"]=="lowLatency")
      setVisibleDisplaySignaling(true);
  }
  const sendYaml=(validationUrl,params,editId)=>{
    httpPut(validationUrl, params).then((res)=>{
      setSignaling(res.signaling);
      setYaml(res.yaml);
      setInfos({ info:["Yaml sent successfully"]});
      canDisplaySignalingButton();
      setVisibleDisplayYaml(true);
      setTimeout(() => {
        setInfos({});
      }, 2000);
    }).catch(error=>{
       const messages = error.errors;
          setErrors(messages);
          setTimeout(() => {
            setErrors({});
        }, 5000);
    });
  }

  const handlerOnUpload = () => {
    setDisableForm(true);
  };

  const handlerOnCompletedUploadFiles = () => {
    setDisableForm(false);
  };

  const handlerOnCanceledUploadFiles = () => {
    setDisableForm(false);
  };
  
  const handlerOnPopupOpenned=(value)=>{
    if(value==false){
      if(storeSocketMessages.length>0){
        runSocketMessages(storeSocketMessages);
      }
      if(storeSocketNavigationMessages.length>0){
        // console.log("run stored",storeSocketNavigationMessages);
        runSocketNavigationMessages(storeSocketNavigationMessages);
      }
    }
    stopSocketMessages=value;
  }
  const runSocketNavigationMessages=(msgs)=>{
    msgs.forEach((msg)=>{
     calculateUserNavigation(msg);
    });
  }

  const runSocketMessages=(msgs)=>{
    msgs.forEach((msg)=>{
      for(let item in configFile.websocketItems){
        updateLocalItem(msg[configFile.websocketItems[item]],configFile.websocketItems[item]);
      }
    });
  }

  const onBroadCastingNavigationReceived = (e) =>{
    console.log("broadcasting 1");
    if(e.data){
      if(stopSocketMessages){
        storeSocketNavigationMessages.push(JSON.parse(e.data));
      }else{
        storeSocketNavigationMessages=[];
        runSocketNavigationMessages([JSON.parse(e.data)]);
      }
    }
  }
  const onBroncastingReceived = (e) => {
    console.log("broadcasting 2");
    if(e.message){
      if(stopSocketMessages){
        storeSocketMessages.push(e.message);
      }else{
        storeSocketMessages=[];
        runSocketMessages([e.message]);
      }
    }
  };

  const checkStep=(current,total)=>{
    if(current==1 && total>current){
      setDisabledBack(true);
      setVisibleFinish(false);
      setVisibleNext(true);
    }else if(current==total){
      setVisibleFinish(true);
      setVisibleNext(false);
      setDisabledBack(false);
    }else{
      setVisibleFinish(false);
      setVisibleNext(true);
      setDisabledBack(false);
    }

    //set the default values if don´t exist
    let stepAttribute=configFile.stepConfig.steps[current-1].attributeName;

    let defaultValues={};
    if(paramsHook.id=="new" && !values[stepAttribute]){
      let defaults=getDefaultValuesConfig(current,stepAttribute);
      defaultValues = {...values,[stepAttribute]:{...values[stepAttribute],...defaults}};
      dispatch(updateForm(defaultValues));
    }
  }

  const getDefaultValuesConfig=(step,stepAttribute)=>{
    let defaults={};
    // console.log(configFile.stepConfig.steps[step-1].formConfig);
    configFile.stepConfig.steps[step-1].formConfig.forEach(formGroup=>{
    
      formGroup.fields.forEach(field=>{
        if(field.default){
          defaults={...defaults,...{[field.attributeName]:field.default}};
        }
      });
    });
    return defaults;
  }
  const checkMasterNavigation=(navigations)=>{
    let myUserMaster=false;
    let masterEmail="";
    for(let item in navigations){
      if(navigations[item].email==JSON.parse(serializedState).sessionEmail){
        if(navigations[item].first==1){
          myUserMaster=true;
          masterEmail=navigations[item].email;
        }else{
          myUserMaster= false;
        }
      }else if(navigations[item].first==1){
        masterEmail=navigations[item].email;
      }
    };
    let res={"result":myUserMaster,"master":masterEmail};
    return res;
  }

  const checkValidationStep=(current,force=false)=>{
    var promise = new Promise( (resolve, reject) => {
      let validationUrl=configFile.stepConfig.validationUrl;
      let editId;
      if(paramsHook.id!="new")
        editId=paramsHook.id;
      
      let params={'step':current,'values':values};
      if(validationUrl && (formHasChanged|| force)){
        let check=checkMasterNavigation(userNavigation);
        if(check.result==false && configFile.navigationBlockReaders){
          swal({
            title: 'Hey reader',
            text: check.master+" is editing the page and you cannot make changes on this page. If you want to make changes, click on your user avatar (top right) and 'become master'",
            icon: 'warning',
            buttons:["Cancel","Only Next"],
            // dangerMode: true,
          }).then((ok) => {
            if(ok){
              return resolve({status:true});
            }
          });
        }else{
          if(current>1 && current<4){
            let textCopy="";
            switch(current){
              case 2:
                textCopy="The ingest set up on this step will automatically fill some parameters on next steps";
                break;
              default:
                textCopy="Save and continue to the next step";
            }

            swal({
              title: 'Save and continue?',
              text: textCopy,
              icon: 'warning',
              buttons:["Cancel","Save and Next"],
              // dangerMode: true,
            }).then((ok) => {
              if(ok){
                  saveChanges(resolve,reject,validationUrl,params,editId);
              }
            }).catch(e=>{
                  if(e.errors){
                    swal('Error', e.errors.error[0], 'error');
                    // alert(error.errors.error[0]);
                  }
            });
          }else
            saveChanges(resolve,reject,validationUrl,params,editId);
        }

      }else{
        return resolve({status:true});
      }
    });
    return promise;
   
  }
  const saveChanges=(resolve,reject,validationUrl,params,editId=null)=>{
    if(editId){
      validationUrl+="/"+editId;
      httpPut(validationUrl, params).then((res)=>{
        resolve({status:true,value:res.value, isNew: false,});
      }).catch(error=>{
        reject(error);
      });
    }else{
      httpPost(validationUrl, params).then((res)=>{        
        setFormHasChanged(false);
        navigate(`../edit/${res.id}`, { replace: true, 
          state: {
            from: location.pathname,
          }, 
        });
        resolve({status:true,value:res.value, isNew: true,});
      }).catch(error=>{
        reject(error);
      });
    }
  }

  useEffect(() => {
    setErrors({});
    setInfos({});
    if (checkObjectAttributes(session, configFile.sessionParams)) {
      if (id !== 'new') {
        const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
        getItem(url);
      }
      if (configFile.additionaMetadataURL) {
        const url = composeURL(
          session,
          configFile.sessionParams,
          configFile.additionaMetadataURL,
          id,
        );
        getAdditionalMetadata(url);
      }
    }
    return function cleanup() {
      resetForm();
      resetAdditionalMetadata();
    };
  }, [ getItem, getAdditionalMetadata, resetForm, resetAdditionalMetadata, session.areaId, session.appId, id,]);

  useEffect(()=>{
    if(values.usersNavigation && JSON.stringify(values.usersNavigation)!=JSON.stringify(userNavigation)){
      calculateUserNavigation(values.usersNavigation);
    }
    if ((values?.isTemplate && !values?.statusHash)|| checkDynamicCondition(configFile.forceChangedWhen, values)) {
      setFormHasChanged(true);
    }
  },[values]);
  
  useEffect(()=> {
    //initialize object values
    let newValues ={};
    stopSocketMessages=false;
    let initStep=1;
    if(id=="new"){
      setFormHasChanged(true);
      setVisibleDisplaySignaling(false);
      setVisibleDisplayYaml(false);
      setSignaling(null);
      setYaml(null);
      setShowPopupSignaling(false);
      setShowPopupYaml(false);
      stopSocketMessages=true;
    }
    setCurrentStep(initStep);
    setCurrentStepValues(configFile.stepConfig.steps[initStep-1].formConfig);
    checkStep(initStep,configFile.stepConfig.steps.length);
    let location=window.location.pathname;
    let locationArr = location.split("/");
    setPage(locationArr[2]);
  },[]);
  useEffect(() => {
    if (configFile.saveIdSessionNameAs && id != 'new') {
      const newSession = {};
      newSession[configFile.saveIdSessionNameAs] = id;
      dispatch(createSession(newSession));
      return () => {
        // Removing the sesion param for this form
        dispatch(removeSession(configFile.saveIdSessionNameAs));
      };
    }
  }, [id]);
  const handleOnClosePopup=()=>{
    setShowModalTemplate(false);
  }
  const handlerOnChangeTemplateName=(e)=>{
    setTemplateName(e.target.value);
  }
  const handlerClosePopupSignaling=()=>{
    setShowPopupSignaling(false);
  }
  const handlerClosePopupYaml=()=>{
    setShowPopupYaml(false);
  }
  const signalingConfigFile=()=>{
    return [{title: 'Signaling',
      attributeName: 'signaling',
      hiddenJsonComponent:true,
      fields: [
        {
          attributeName: 'signaling',
          label: '',
          helpText: 'Signaling.',
          type: FormInputTypes.JSON,
        }]
      }];
    }
    const yamlConfigFile=()=>{
      return [{title: 'Yaml',
        attributeName: 'yaml',
        hiddenJsonComponent:true,
        fields: [
          {
            attributeName: 'yaml',
            label: '',
            helpText: 'Yaml.',
            type: FormInputTypes.YAML,
          }]
        }];
      } 
    const checkDynamicCondition = (condition, data) => {
      if (!condition || !data) return false;

      const currentValue = data[condition.field];

      if (Array.isArray(condition.value)) {
        return condition.value.includes(currentValue);
      }

      return currentValue === condition.value;
    };
      return (
        <div>
       {showModalTemplate && <Modal
          title={"Save template"}
          onClose={handleOnClosePopup}
          size={ModalSize.LARGE}
          >
          <div>
           
           {Object.keys(popupErrors).length > 0
          && (
            <Toaste type="error" mode="toast" data={popupErrors} />
          )}
        
         <div>Write a name to identify the template<br/><br/>
          <FormInputText
                id={"templateName"}
                name={"Template name"}
                placeholder={"name here..."}
                helpText={"Name of the template you are about to save"}
                type={"text"}
                // value={value ? value[field.attributeName] : ''}
                value={(templateName?templateName:'')}
                label={"Template name"}
                onChange={handlerOnChangeTemplateName}
              />
         </div>
         </div>
         <div style={{width:'100%'}}>
          <div style={{float:'left'}}>
          <Button
            id={`button-cancel`}
            type={ButtonType.BUTTON}
            onClick={() => handleOnClosePopup()}
            theme={ButtonTheme.SECONDARY}
            >
            Cancel
          </Button>
          </div>
          <div style={{float:'right'}}>
            <Button 
              id={`button-ok`}
              theme={ButtonTheme.PRIMARY}
              onClick={handlePopupOK}
            >
              Ok
            </Button>
          </div>
          </div>
        </Modal>}
    { configFile.websocketChannel
      && (
        <Broadcast
          eventChanel={configFile.websocketChannel}
          sessionParams={configFile.websocketSessionParams}
          onEventReceived={(e) => { onBroncastingReceived(e); }}
        />
      )}
       {configFile.websocketNavigation
      && (
        <Broadcast
          eventChanel={configFile.websocketNavigation}
          sessionParams={[]}
          onEventReceived={(e) => { onBroadCastingNavigationReceived(e); }}
        />
      )}
      { configFile.noArea
      && (
        <SimplePageTitle lockIcon={configFile.navigationBlockReaders} myEmail={JSON.parse(serializedState).sessionEmail} userNavigation={userNavigation}>{configFile.title}</SimplePageTitle>
      )}
      { (configFile.noArea === undefined || configFile.noArea === false)
      && (
        <PageTitle>{configFile?.title}</PageTitle>
      )}
      {(errors && (Array.isArray(errors) ? errors.length : Object.keys(errors).length) > 0)
        && <Toaste type="error" mode="toast" data={errors} />
      }
      { Object.keys(infos).length > 0
      && (
          <Toaste type="info" mode="toast" data={infos}/>
      )}
        {configFile.formGroupExpands !== true && Array.isArray(configFile.formConfig) === true
      && configFile.formConfig.map((formGroup) => (
        <FormGroup
          key={`${configFile.attributeName}-${formGroup.attributeName}`}
          configFile={formGroup}
          value={values}
        />
      ))}
      <Stepper current={currentStep} steps={configFile.stepConfig.steps}/>
        <Form>
          {currentStep && values[getStepAttribute(currentStep)] && Array.isArray(configFile.stepConfig.steps[currentStep-1].formConfig) === true
          && configFile.stepConfig.steps[currentStep-1].formConfig.map((formGroup) => {
            return (
            <FormGroup
              key={`${configFile.attributeName}-${formGroup.attributeName}`}
              configFile={formGroup}
              value={values[getStepAttribute(currentStep)]}
              onChange={handlerOnChange}
              onUpload={handlerOnUpload}
              onCompletedUploadFiles={handlerOnCompletedUploadFiles}
              onCanceledUploadFiles={handlerOnCanceledUploadFiles}
              params={values[getStepAttribute(currentStep)]}
              onPopupOpenned={handlerOnPopupOpenned}
            />
            );
          })}
        
          <FooterWizardButtons
            idNext={`${configFile.attributeName}-nextButton`}
            idBack={`${configFile.attributeName}-backButton`}
            idFinish={`${configFile.attributeName}-finishButton`}
            idYamlSent={`${configFile.attributeName}-yamlButton`}
            idSignaling={`${configFile.attributeName}-signalingButton`}
            idYamlSignaling={`${configFile.attributeName}-yaml2Button`}
            idSaveTemplate={`${configFile.attributeName}-saveTemplateButton`}
            visibleFinish={visibleFinish}
            visibleNext={visibleNext}
            visibleYamlSent={visibleYamlSent}
            visibleDisplaySignaling={visibleDisplaySignaling}
            visibleDisplayYaml={visibleDisplayYaml}
            formHasChanged={formHasChanged}
            disabledBack={disabledBack}
            onNext={handlerNextbutton}
            onBack={handlerBackButton}
            onFinish={handlerFinishButton}
            onYamlSent={handlerYamlSentButton}
            onDisplaySignaling={handlerDisplaySignaling}
            onDisplayYaml={handlerDisplayYaml}
            onSaveTemplate={handlerSaveTemplate}
            disabled={disableForm}
            page={page}
            userNavigation={userNavigation}
            myEmail={JSON.parse(serializedState).sessionEmail}
            navigationBlockReaders={configFile.navigationBlockReaders}
          >
          </FooterWizardButtons>
      </Form>
      {visibleDisplaySignaling && showPopupSignaling && signaling && 
       <FormPopup size={'xl'} id={"signaling"} mode={"view"} nextId={"1"} title={"Signaling"} configFile={signalingConfigFile()} field={"signaling"} value={{"signaling":signaling}} show={showPopupSignaling} onClosePopup={handlerClosePopupSignaling}/>
      }
      {visibleDisplayYaml && showPopupYaml && yaml && 
        <FormPopup size={'xl'} id={"yaml"} mode={"view"} nextId={"1"} title={"Yaml"} configFile={yamlConfigFile()} field={"yaml"} value={{"yaml":yaml}} show={showPopupYaml} onClosePopup={handlerClosePopupYaml}/>
      }
    </div>
  );
};

FormWizardTemplate.propTypes = {
  configFile: PropTypes.shape({
    attributeName: PropTypes.string,
    title: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    getURL: PropTypes.string,
    additionaMetadataURL: PropTypes.string,
    saveIdSessionNameAs: PropTypes.string,
    updateURL: PropTypes.string,
    removeURL: PropTypes.string,
    formConfig: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
    idAttribute: PropTypes.string,
    goBack: PropTypes.bool,
    noArea: PropTypes.bool,
    websocketChannel: PropTypes.string,
    websocketSessionParams: PropTypes.arrayOf(PropTypes.string),
    websocketItem: PropTypes.string,
  }).isRequired,
  getItem: PropTypes.func.isRequired,
  getAdditionalMetadata: PropTypes.func.isRequired,
  resetAdditionalMetadata: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  updateLocalItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathName: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
};

FormWizardTemplate.defaultProps = {

};

export default (connect(null, mapDispatchToProps)(FormWizardTemplate));
